import DatePicker from './src/date-picker'

import type { App } from 'vue'
import type { SFCWithInstall } from '@element-plus/utils'

const _DatePicker = DatePicker as SFCWithInstall<typeof DatePicker>

Reflect.set(_DatePicker, 'install', (app: App) => {
  app.component(_DatePicker.name as string, _DatePicker)
})

export default _DatePicker
export const ElDatePicker = _DatePicker
